import { render } from "./WhoIsFH.vue?vue&type=template&id=392496cd&scoped=true"
const script = {}

import "./WhoIsFH.vue?vue&type=style&index=0&id=392496cd&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Vue-Projects\\ForestPage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392496cd"]])

export default __exports__